import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Award } from '../awards-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<Award, unknown>[] = [
		buildColumn(util, 'Id', row => row.awardId, { header: 'awardId' }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Id', row => row.eventId, { header: 'eventId' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture' }),
		buildColumn(util, 'Text', row => row.awardName, { header: 'Award' }),
		buildColumn(util, 'Dollar', row => row.value, { header: 'Value' }),
		buildColumn(util, 'Text', row => row.kind, { header: 'Kind' }),
		buildColumn(util, 'Text', row => row.awardeeNames, { header: 'Awardee Names' }),
		buildColumn(util, 'Email', row => row.awardeeEmails, { header: 'Awardee Emails' }),
		buildColumn(util, 'Text', row => row.notes, { header: 'Notes' }),
		buildColumn(util, 'Text', row => row.decidedBy, { header: 'Decided By', hidden: true }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Last Updated', hidden: true }),

	];


	return columns;

}